import { useSyncExternalStore } from 'react'

let activeAudioPlayerId: string | null = null
const activeAudioPlayerListeners = new Set<() => void>()

const subscribe = (listener: () => void): (() => void) => {
  activeAudioPlayerListeners.add(listener)

  return () => {
    activeAudioPlayerListeners.delete(listener)
  }
}

const getSnapshot = (): string | null => activeAudioPlayerId
const getServerSnapshot = (): null => null

export const useActiveAudioPlayer = (): readonly [string | null, (id: string | null) => void] => {
  const activeId = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)

  const setActiveId = (id: string | null): void => {
    activeAudioPlayerId = id

    for (const listener of activeAudioPlayerListeners) {
      listener()
    }
  }

  return [activeId, setActiveId] as const
}
